<div class="container">
  <h1 class="display-5 fw-semibold mb-4">Nuestras Convocatorias</h1>

  <div class="row mb-4 align-items-end gy-2">
    <div class="col-md-6 d-flex">
      <div>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input
            type="text"
            class="form-control"
            placeholder="Buscar"
            [(ngModel)]="params.title"
            (ngModelChange)="handleSearch()"
          />
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <select
        class="form-select"
        [(ngModel)]="params.order"
        (ngModelChange)="search()"
      >
        <option value="" selected disabled hidden>Ordenar por</option>
        <option value="recent">Más reciente</option>
        <option value="oldest">Más antiguo</option>
      </select>
    </div>
    <div class="col-md-3">
      <input
        type="date"
        class="form-control"
        [(ngModel)]="params.start_date"
        (ngModelChange)="search()"
      />
    </div>
  </div>

  <div class="row g-3 align-items-start mt-4">
    @for (announcement of announcements; track announcement.id) {
      <div class="col-md-4">
        <a [routerLink]="['/convocatoria', announcement.id]">
          <div class="card text-bg-dark" style="height: 280px">
            <img
              [src]="announcement.image_url"
              class="card-img object-fit-cover"
              height="180"
              alt=""
            />
            <div class="p-2">
              <h5 class="card-title">{{ announcement.title }}</h5>
              <div class="d-flex gap-3">
                <div>
                  <i class="bi bi-clock"></i>
                  {{ announcement.start_date | date: 'dd/MM/yy' }}
                </div>
                |
                <div>
                  <i class="bi bi-clock"></i>
                  {{ announcement.end_date | date: 'dd/MM/yy' }}
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    } @empty {
      @if (loading) {
        @for (placeholder of [1, 2, 3]; track placeholder) {
          <div class="col-md-4 placeholder-glow">
            <span class="placeholder w-100" style="height: 280px"></span>
          </div>
        }
      } @else {
        <div class="col-12">
          <div class="alert alert-secondary text-center" role="alert">
            No hay convocatorias disponibles.
          </div>
        </div>
      }
    }

    @if (!loading) {
      <app-pagination
        [(page)]="params.page"
        [total]="total"
        [limit]="params.limit"
        (pageChange)="getAnnouncements()"
      />
    } @else {
      <div class="d-flex justify-content-end placeholder-glow">
        <span class="placeholder col-4" style="height: 40px"></span>
      </div>
    }
  </div>
</div>
